import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import LowStockTippy from 'app/React/ProductForm/LowStockTippy'
import DisabledSVG from 'app/React/ProductForm/DisabledSVG'
function Variation(props){
  const variation = props.variation
  const [selectedType] = useEnvValue('selectedType',null)
  const [selectedVariation] = useEnvValue('selectedVariation',null)
  const [selectedQuantity] = useEnvValue('selectedQuantity')

  if(selectedType !== null && selectedType !== variation.type) return null // If there is a type selected and this variation does not belong to this type. Hide the variation

  const lowStock = variation.lowStock && variation.stock && variation.stock > 0 ? <LowStockTippy stock={variation.stock}/> : null;

  const classes = function(){
    let classes = []
    if(
      (typeof variation.stock === 'boolean' && variation.stock === false)
      || typeof variation.stock === 'number' && variation.stock < selectedQuantity) classes.push('disabled')
    return classes
  }

  return (
    <label htmlFor={"variation-"+variation.id}>
      <input type="radio" id={"variation-"+variation.id} name={'prima_variation'} value={variation.id} onChange={props.onChange} checked={selectedVariation?.id === variation.id} />
      <span className={classes().join(' ')}>
        {variation.displayName}
        {lowStock}
        <DisabledSVG/>
      </span>
    </label>
  )
}

Variation.defaultProps = {
  disabled: false
}

export default observer(Variation)